export const mockApplications = [
  {
    id: 'APP001',
    source: 'platform' as const,
    icon: 'https://public.readdy.ai/ai/img_res/826d8fb5ce5e2b94b9c12b082740e719.jpg',
    name: '飞书',
    version: 'v6.8.12',
    downloads: 15234,
    status: true,
    developer: '字节跳动',
    category: '办公软件 / 协作工具',
    categoryId: 'CAT001-SUB001',
    userPermission: 'all' as const,
    price: 0,
    type: 'cloud' as const,
    path: '//app/work/oa/feishu',
    launchPath: '../feishu/launch.exe',
    description: '飞书是字节跳动旗下的企业协作平台，集即时通讯、日历、音视频会议、云文档、云盘等功能于一体。',
    detailedDescription: '飞书是字节跳动旗下的企业协作平台，集即时通讯、日历、音视频会议、云文档、云盘、工作台等功能于一体，通过开放兼容的平台，让成员在一处即可实现高效的沟通和流畅的协作，全方位提升企业效率。飞书支持多端同步，随时随地高效办公。',
    tags: ['协作', '办公', '即时通讯', '视频会议', '文档'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Feishu',
    visibleTenants: []
  },
  {
    id: 'APP002',
    source: 'platform' as const,
    icon: 'https://readdy.ai/api/search-image?query=creative%20professional%20graphic%20design%20software%20application%20icon%20with%20artistic%20brush%20and%20palette%20elements%20on%20simple%20white%20background%20in%20vibrant%20colors&width=120&height=120&seq=app002&orientation=squarish',
    name: 'Adobe Photoshop',
    version: 'v24.5.0',
    downloads: 28956,
    status: true,
    developer: 'Adobe Inc.',
    category: '设计工具 / 图像处理',
    categoryId: 'CAT002-SUB001',
    userPermission: 'partial' as const,
    price: 99,
    type: 'cloud' as const,
    path: '//app/design/adobe/photoshop',
    launchPath: '../photoshop/Photoshop.exe',
    description: 'Adobe Photoshop是全球最专业的图像处理软件，提供强大的图像编辑和设计功能。',
    detailedDescription: 'Adobe Photoshop是Adobe公司旗下最为出名的图像处理软件之一，集图像扫描、编辑修改、图像制作、广告创意，图像输入与输出于一体的图形图像处理软件，深受广大平面设计人员和电脑美术爱好者的喜爱。',
    tags: ['设计', '图像处理', '修图', 'PS', '创意'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Adobe\\Photoshop',
    visibleTenants: ['TENANT001', 'TENANT003']
  },
  {
    id: 'APP003',
    source: 'user' as const,
    icon: 'https://readdy.ai/api/search-image?query=modern%20code%20editor%20programming%20software%20application%20icon%20with%20code%20brackets%20and%20terminal%20elements%20on%20simple%20white%20background%20in%20tech%20blue%20colors&width=120&height=120&seq=app003&orientation=squarish',
    name: 'Visual Studio Code',
    version: 'v1.85.2',
    downloads: 45678,
    status: true,
    developer: 'Microsoft',
    category: '开发工具 / 代码编辑器',
    categoryId: 'CAT003-SUB001',
    userPermission: 'all' as const,
    price: 0,
    type: 'cloud' as const,
    path: '//app/dev/vscode',
    launchPath: '../vscode/Code.exe',
    description: 'Visual Studio Code是微软推出的轻量级代码编辑器，支持多种编程语言和丰富的插件生态。',
    detailedDescription: 'Visual Studio Code（简称VS Code）是一款由微软开发且跨平台的免费源代码编辑器。该软件支持语法高亮、代码自动补全、代码重构、查看定义功能，并且内置了命令行工具和Git版本控制系统。用户可以更改主题和键盘快捷方式实现个性化设置，也可以通过内置的扩展程序商店安装扩展以拓展软件功能。',
    tags: ['编程', '开发', '代码编辑器', 'IDE', '微软'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\VSCode',
    visibleTenants: []
  },
  {
    id: 'APP004',
    source: 'platform' as const,
    icon: 'https://readdy.ai/api/search-image?query=professional%20video%20editing%20software%20application%20icon%20with%20film%20strip%20and%20play%20button%20elements%20on%20simple%20white%20background%20in%20cinematic%20colors&width=120&height=120&seq=app004&orientation=squarish',
    name: 'Premiere Pro',
    version: 'v23.6.0',
    downloads: 18234,
    status: true,
    developer: 'Adobe Inc.',
    category: '设计工具 / 视频编辑',
    categoryId: 'CAT002-SUB002',
    userPermission: 'partial' as const,
    price: 149,
    type: 'cloud' as const,
    path: '//app/design/adobe/premiere',
    launchPath: '../premiere/Premiere Pro.exe',
    description: 'Adobe Premiere Pro是业界领先的视频编辑软件，为电影、电视和Web提供专业的视频编辑解决方案。',
    detailedDescription: 'Adobe Premiere Pro是一款常用的视频编辑软件，由Adobe公司推出。现在常用的版本有CS4、CS5、CS6、CC 2014、CC 2015、CC 2017、CC 2018、CC 2019、CC 2020、CC 2021以及2022版本。Adobe Premiere是一款编辑画面质量比较好的软件，有较好的兼容性，且可以与Adobe公司推出的其他软件相互协作。',
    tags: ['视频编辑', '剪辑', '后期制作', 'PR', '影视'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Adobe\\Premiere Pro',
    visibleTenants: ['TENANT001', 'TENANT002']
  },
  {
    id: 'APP005',
    source: 'platform' as const,
    icon: 'https://readdy.ai/api/search-image?query=modern%20web%20browser%20application%20icon%20with%20globe%20and%20navigation%20elements%20on%20simple%20white%20background%20in%20colorful%20gradient%20design&width=120&height=120&seq=app005&orientation=squarish',
    name: 'Chrome浏览器',
    version: 'v120.0.6099',
    downloads: 67890,
    status: true,
    developer: 'Google',
    category: '网络工具 / 浏览器',
    categoryId: 'CAT004-SUB001',
    userPermission: 'all' as const,
    price: 0,
    type: 'cloud' as const,
    path: '//app/network/chrome',
    launchPath: '../chrome/chrome.exe',
    description: 'Google Chrome是一款快速、安全且免费的网络浏览器，为现代网络而打造。',
    detailedDescription: 'Google Chrome是由Google开发的免费网页浏览器。Chrome是化学元素"铬"的英文名称，过去也用Chrome称呼浏览器的外框。Chrome相应的开放源代码计划名为Chromium，而Google Chrome本身是非自由软件，未开放源代码。',
    tags: ['浏览器', '网络', '谷歌', '上网', '快速'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Google\\Chrome',
    visibleTenants: []
  },
  {
    id: 'APP006',
    source: 'user' as const,
    icon: 'https://readdy.ai/api/search-image?query=professional%203d%20modeling%20software%20application%20icon%20with%20geometric%20shapes%20and%20wireframe%20elements%20on%20simple%20white%20background%20in%20modern%20design&width=120&height=120&seq=app006&orientation=squarish',
    name: 'Blender',
    version: 'v4.0.2',
    downloads: 12456,
    status: true,
    developer: 'Blender Foundation',
    category: '设计工具 / 3D建模',
    categoryId: 'CAT002-SUB003',
    userPermission: 'all' as const,
    price: 0,
    type: 'cloud' as const,
    path: '//app/design/blender',
    launchPath: '../blender/blender.exe',
    description: 'Blender是一款免费开源的3D创作套件，支持建模、雕刻、动画、渲染等全流程制作。',
    detailedDescription: 'Blender是一款免费开源的3D创作套件。它支持整个3D管道建模、装配、动画、模拟、渲染、合成和运动跟踪，甚至视频编辑和游戏创建。高级用户使用Blender的API进行Python脚本来自定义应用程序和编写专用工具。',
    tags: ['3D建模', '动画', '渲染', '开源', '设计'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Blender Foundation\\Blender',
    visibleTenants: []
  },
  {
    id: 'APP007',
    source: 'platform' as const,
    icon: 'https://readdy.ai/api/search-image?query=enterprise%20communication%20software%20application%20icon%20with%20chat%20bubble%20and%20team%20collaboration%20elements%20on%20simple%20white%20background%20in%20professional%20green%20colors&width=120&height=120&seq=app007&orientation=squarish',
    name: '企业微信',
    version: 'v4.1.8',
    downloads: 34567,
    status: true,
    developer: '腾讯',
    category: '办公软件 / 协作工具',
    categoryId: 'CAT001-SUB001',
    userPermission: 'all' as const,
    price: 0,
    type: 'cloud' as const,
    path: '//app/work/wework',
    launchPath: '../wework/WXWork.exe',
    description: '企业微信是腾讯推出的企业通讯与办公工具，连接微信生态，助力企业数字化转型。',
    detailedDescription: '企业微信是腾讯微信团队为企业打造的专业办公管理工具。与微信一致的沟通体验，丰富免费的OA应用，并与微信消息、小程序、微信支付等互通，助力企业高效办公和管理。企业微信还提供了丰富的开放接口，可以与企业现有系统集成。',
    tags: ['企业通讯', '办公', '协作', '腾讯', 'OA'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Tencent\\WXWork',
    visibleTenants: []
  },
  {
    id: 'APP008',
    source: 'platform' as const,
    icon: 'https://readdy.ai/api/search-image?query=professional%20cad%20engineering%20software%20application%20icon%20with%20blueprint%20and%20technical%20drawing%20elements%20on%20simple%20white%20background%20in%20industrial%20blue%20colors&width=120&height=120&seq=app008&orientation=squarish',
    name: 'AutoCAD',
    version: 'v2024.1',
    downloads: 9876,
    status: false,
    developer: 'Autodesk',
    category: '设计工具 / CAD设计',
    categoryId: 'CAT002-SUB004',
    userPermission: 'partial' as const,
    price: 299,
    type: 'cloud' as const,
    path: '//app/design/autocad',
    launchPath: '../autocad/acad.exe',
    description: 'AutoCAD是Autodesk公司开发的自动计算机辅助设计软件，用于二维绘图、详细绘制、设计文档和基本三维设计。',
    detailedDescription: 'AutoCAD是由美国Autodesk欧特克公司于二十世纪八十年代初为微机上应用CAD技术而开发的绘图程序软件包，经过不断的完善，现已经成为国际上广为流行的绘图工具。AutoCAD具有良好的用户界面，通过交互菜单或命令行方式便可以进行各种操作。',
    tags: ['CAD', '工程设计', '制图', '建筑', '机械'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Autodesk\\AutoCAD',
    visibleTenants: ['TENANT001']
  },
  {
    id: 'APP009',
    source: 'web' as const,
    icon: 'https://readdy.ai/api/search-image?query=modern%20project%20management%20web%20application%20icon%20with%20task%20board%20and%20timeline%20elements%20on%20simple%20white%20background%20in%20organized%20layout%20design&width=120&height=120&seq=app009&orientation=squarish',
    name: 'Notion',
    version: 'Web v2.28',
    downloads: 23456,
    status: true,
    developer: 'Notion Labs',
    category: '办公软件 / 笔记工具',
    categoryId: 'CAT001-SUB002',
    userPermission: 'all' as const,
    price: 0,
    type: 'web' as const,
    path: 'https://www.notion.so',
    launchPath: '',
    description: 'Notion是一款集笔记、知识库、数据表格、看板、日历等多种能力于一体的应用程序。',
    detailedDescription: 'Notion是一款提供笔记、任务、数据库、看板、维基、日历和提醒等组件的应用程序。用户可以将这些组件连接起来，来创建自己的系统，用于知识管理、笔记记录、数据管理、项目管理等。这些组件和系统可以单独使用，也可以跨平台使用。',
    tags: ['笔记', '知识管理', '协作', '文档', '项目管理'],
    visibleTenants: []
  },
  {
    id: 'APP010',
    source: 'user' as const,
    icon: 'https://readdy.ai/api/search-image?query=professional%20data%20analysis%20software%20application%20icon%20with%20spreadsheet%20and%20chart%20elements%20on%20simple%20white%20background%20in%20business%20green%20colors&width=120&height=120&seq=app010&orientation=squarish',
    name: 'Microsoft Excel',
    version: 'v2021',
    downloads: 56789,
    status: true,
    developer: 'Microsoft',
    category: '办公软件 / 数据处理',
    categoryId: 'CAT001-SUB003',
    userPermission: 'all' as const,
    price: 0,
    type: 'cloud' as const,
    path: '//app/office/excel',
    launchPath: '../excel/EXCEL.EXE',
    description: 'Microsoft Excel是微软办公套装软件的一个重要组成部分，可以进行各种数据的处理、统计分析和辅助决策操作。',
    detailedDescription: 'Microsoft Excel是Microsoft为使用Windows和Apple Macintosh操作系统的电脑编写的一款电子表格软件。直观的界面、出色的计算功能和图表工具，再加上成功的市场营销，使Excel成为最流行的个人计算机数据处理软件。',
    tags: ['表格', '数据分析', '办公', '统计', '微软'],
    registryKey: 'HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\Office\\Excel',
    visibleTenants: []
  }
];

export const mockCategories: any[] = [
  {
    id: 'CAT001',
    name: '办公软件',
    status: true,
    sort: 1,
    productCount: 15,
    children: [
      { id: 'CAT001-SUB001', name: '协作工具', status: true, sort: 1, parentId: 'CAT001', productCount: 8 },
      { id: 'CAT001-SUB002', name: '笔记工具', status: true, sort: 2, parentId: 'CAT001', productCount: 4 },
      { id: 'CAT001-SUB003', name: '数据处理', status: true, sort: 3, parentId: 'CAT001', productCount: 3 }
    ]
  },
  {
    id: 'CAT002',
    name: '设计工具',
    status: true,
    sort: 2,
    productCount: 22,
    children: [
      { id: 'CAT002-SUB001', name: '图像处理', status: true, sort: 1, parentId: 'CAT002', productCount: 6 },
      { id: 'CAT002-SUB002', name: '视频编辑', status: true, sort: 2, parentId: 'CAT002', productCount: 5 },
      { id: 'CAT002-SUB003', name: '3D建模', status: true, sort: 3, parentId: 'CAT002', productCount: 7 },
      { id: 'CAT002-SUB004', name: 'CAD设计', status: true, sort: 4, parentId: 'CAT002', productCount: 4 }
    ]
  },
  {
    id: 'CAT003',
    name: '开发工具',
    status: true,
    sort: 3,
    productCount: 18,
    children: [
      { id: 'CAT003-SUB001', name: '代码编辑器', status: true, sort: 1, parentId: 'CAT003', productCount: 8 },
      { id: 'CAT003-SUB002', name: '数据库工具', status: true, sort: 2, parentId: 'CAT003', productCount: 6 },
      { id: 'CAT003-SUB003', name: '版本控制', status: true, sort: 3, parentId: 'CAT003', productCount: 4 }
    ]
  },
  {
    id: 'CAT004',
    name: '网络工具',
    status: true,
    sort: 4,
    productCount: 12,
    children: [
      { id: 'CAT004-SUB001', name: '浏览器', status: true, sort: 1, parentId: 'CAT004', productCount: 5 },
      { id: 'CAT004-SUB002', name: '下载工具', status: true, sort: 2, parentId: 'CAT004', productCount: 4 },
      { id: 'CAT004-SUB003', name: '远程工具', status: true, sort: 3, parentId: 'CAT004', productCount: 3 }
    ]
  },
  {
    id: 'CAT005',
    name: '娱乐软件',
    status: false,
    sort: 5,
    productCount: 8,
    children: [
      { id: 'CAT005-SUB001', name: '音乐播放', status: true, sort: 1, parentId: 'CAT005', productCount: 3 },
      { id: 'CAT005-SUB002', name: '视频播放', status: true, sort: 2, parentId: 'CAT005', productCount: 5 }
    ]
  }
];

export const mockTenants = [
  { id: 'TENANT001', name: '阿里巴巴集团', type: 'enterprise' },
  { id: 'TENANT002', name: '腾讯科技', type: 'enterprise' },
  { id: 'TENANT003', name: '字节跳动', type: 'enterprise' },
  { id: 'TENANT004', name: '清华大学', type: 'school' },
  { id: 'TENANT005', name: '北京大学', type: 'school' },
  { id: 'TENANT006', name: '复旦大学', type: 'school' },
  { id: 'TENANT007', name: '上海交通大学', type: 'school' },
  { id: 'TENANT008', name: '华为技术有限公司', type: 'enterprise' }
];

export const availableTags = [
  '协作', '办公', '即时通讯', '视频会议', '文档',
  '设计', '图像处理', '修图', 'PS', '创意',
  '编程', '开发', '代码编辑器', 'IDE', '微软',
  '视频编辑', '剪辑', '后期制作', 'PR', '影视',
  '浏览器', '网络', '谷歌', '上网', '快速',
  '3D建模', '动画', '渲染', '开源',
  'CAD', '工程设计', '制图', '建筑', '机械',
  '笔记', '知识管理', '项目管理',
  '表格', '数据分析', '统计'
];
